module.exports = __webpack_public_path__ + "static/media/pt.0b42d234.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/pt.png
// module id = 1962
// module chunks = 0